import { Button, GBTypography } from '@leapfinance/geebee-component-library';
import { Close } from '@mui/icons-material';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';

import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { close } from '@/features/confirmDialog/confirmDialogSlice';

const ConfirmDialog = () => {
  const { onSubmit, message, title, onCancel } = useAppSelector(
    (state) => state.confirmDialog,
  );
  const dispatch = useAppDispatch();

  return (
    <Dialog open={Boolean(onSubmit)} maxWidth="sm" fullWidth>
      <DialogTitle className="font-sans">
        <GBTypography variant="h2">{title}</GBTypography>
      </DialogTitle>
      <Box position="absolute" top={15} right={10}>
        <IconButton
          onClick={() => {
            onCancel?.();
            dispatch(close());
          }}
          className="no-disable-button"
        >
          <Close />
        </IconButton>
      </Box>
      <DialogContent>
        <GBTypography variant="body3">{message}</GBTypography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onCancel?.();
            dispatch(close());
          }}
          sx={{
            backgroundColor: `#BA3B3B`,
            ':hover': {
              backgroundColor: `#BA3B3B`,
              opacity: 0.8,
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            if (onSubmit) {
              onSubmit();
            }
            dispatch(close());
          }}
        >
          Confirm
        </Button>
        {/* <CustomButton
          text="Cancel"
          onClick={() => {
            onCancel?.();
            dispatch(close());
          }}
          sx={{
            backgroundColor: `#BA3B3B`,
            ':hover': {
              backgroundColor: `#BA3B3B`,
              opacity: 0.8,
            },
          }}
        /> */}
        {/* <CustomButton
          text="Confirm"
          className="hover:opacity-80"
          onClick={() => {
            if (onSubmit) {
              onSubmit();
            }
            dispatch(close());
          }}
        /> */}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
